/**
 * @param {HTMLElement} element
 */
export default function initializeWebsite(element) {
  element.classList.add('--loaded');
}
